import { useBackend } from "../../services";

export const useRemoveAllAlbumsFromShelfSegment = () => {
  const { deleteRequest } = useBackend();
  const removeAllAlbumsFromShelfSegment = (
    parameters: IRemoveAllAlbumsFromShelfSegmentParameters
  ) => deleteRequest("shelfSegments/allAlbums", parameters);
  return { removeAllAlbumsFromShelfSegment };
};

export interface IRemoveAllAlbumsFromShelfSegmentParameters {
  uuid: string;
}
